module.exports = __webpack_public_path__ + "img/2 Bridge logo.49c275aa.jpg";